<div class="plus-btn-property" *ngIf="tableFlag">
  <button type="button" class="btn add-btn-outline1" (click)="addNewMetroSetup()">
    <em class="bx bx-plus me-1"></em>
    Add Metro Setup
  </button>
</div>

<div class="col-sm-12" *ngIf="setupFlag">
  <div class="d-flex">
    <button style="border: none !important;" class="btn btn-primary1" (click)="onBack()">
      <span class="back-light"><em class="mdi mdi-arrow-left me-2"></em>Back</span>
    </button>
    <h4 class="addEditBtn" style="margin-top: 10px;">/ {{title}} Metro Setup</h4>
  </div>
</div>

<div class="row mt-3" *ngIf="setupFlag">
  <div class="col-sm-12">
    <form [formGroup]="metroForm">
      <div class="row">
        <div class="col-sm-3">
          <label>Site<sup class="mandatory">*</sup></label>
          <select class="form-select" placeholder="Select Site" formControlName="site" required>
            <option disabled value="">Choose Site</option>
            <option *ngFor="let site of sites" [value]="site.siteId">
              {{ site.siteName}}
            </option>
          </select>
        </div>
        <div class="col-sm-3">
          <label for="stationName">Station Name<sup class="mandatory">*</sup></label>
          <input type="text" maxlength="20" class="form-control" formControlName="stationName"
            placeholder="Enter Station Name" (keypress)="discard_special_char_And_String($event)">
        </div>
        <div class="col-sm-3">
          <label for="metroRouteName">Metro Route Name<sup class="mandatory">*</sup></label>
          <input type="text" class="form-control" (keypress)="discard_special_char_And_String($event)"
            formControlName="metroRouteName" placeholder="Enter Metro Route Name">
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-sm-3">
          <label for="latitude">Latitude<sup class="mandatory">*</sup></label>
          <input type="text" class="form-control" formControlName="latitude" placeholder="Enter Latitude"
            (keypress)="ontypeLatandLong($event)">
        </div>
        <div class="col-sm-3">
          <label for="longitude">Longitude<sup class="mandatory">*</sup></label>
          <input type="text" class="form-control" formControlName="longitude" placeholder="Enter Longitude"
            (keypress)="ontypeLatandLong($event)">
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12 d-flex justify-content-end">
          <button type="button" [disabled]="metroForm.invalid" style="height: 35px;" class="btn metro-btn-solid"
            (click)="onSubmit()">
            Submit
          </button>
        </div>
      </div>
    </form>
  </div>
</div>

<div class="row" *ngIf="tableFlag && tableData.length > 0">
  <div class="col-sm-12">
    <app-basic-table [columnHeaders]="_mColumns" [tableData]="tableData" (onStatusChanged)="onStatusChanged($event)"
      [subcribeEdit]="true" (onEditIconClicked)="onEditIconClicked($event)"></app-basic-table>
  </div>
</div>

<div class="row mt-5" *ngIf="tableData.length == 0">
  <div class="col-sm-12 col-md-12">
    <h4 class="tdw-text-align-center tdw-font-normal tdw-margin-4
            mat-color-text--blue-grey-600">
      --No Data Found --</h4>
  </div>
</div>